import { Paragraph, PcaHeading } from "../theme/typography";

import { ForwardButton } from "../simple-buttons/simple-buttons";
import { ReactComponent as NotFoundPageImage } from "./icons/notFoundPageImage.svg";
import { PageContainer } from "../theme/containers";
import React from "react";

const title = "Even the things we love break sometimes...";
const description =
    "Sorry, we couldn't find the page you are looking for. In the meantime you can:";

const NotFoundPage = (props: any) => {
    return (
        <PageContainer className="not-found-container" pt={[9, 9, 15]}>
            <NotFoundPageImage />
            {title && (
                <PcaHeading className={`line-break overflow-ellipsis`}>
                    {title}
                </PcaHeading>
            )}
            {description && <Paragraph>{description}</Paragraph>}
            <ForwardButton
                as="a"
                background="transparent"
                bordercolor="transparent"
                mx="0"
                height="3.1875rem"
                href="https://www.bankofireland.com/"
                >
                Go to our main website
            </ForwardButton>
            <ForwardButton
                as="a"
                background="transparent"
                bordercolor="transparent"
                mx="0"
                height="3.1875rem"
                href="https://www.bankofireland.com/help-centre/"
                >
                Go to our help centre
            </ForwardButton>
            {props.children}
        </PageContainer>
    );
};

export default NotFoundPage;
